import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function AddSchedule() {
  const userID = sessionStorage.getItem("TRCUserId");
  const navigate = useNavigate();

  const [scheduleData, setScheduleData] = useState({
    clientId: "",
    scheduleDate: "",
    Type: "",
    status: "Pending",
    remarks: "",
  });

  const [clientData, setClientData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    getClient();
  }, []);

  useEffect(() => {
    setFilteredOptions(
      clientData.filter((client) =>
        client.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, clientData]);

  const getClient = async () => {
    try {
      const response = await axios.post(
        "https://api.trucoo.in/clients/clients/",
        { userId: userID },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      if (response.data.status === "success") {
        setClientData(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
    }
  };

  const handleSelect = (clientId) => {
    setScheduleData((prevData) => ({
      ...prevData,
      clientId,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setScheduleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const submitSchedule = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.trucoo.in/marketing/add-schedules/",
        { ...scheduleData, userId: userID },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      if (response.data.status === "success") {
        alert("Schedule added successfully!");
        setScheduleData({
          clientId: "",
          scheduleDate: "",
          Type: "",
          status: "",
          remarks: "",
        });
      } else {
        alert("Error adding schedule!");
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
      alert("Failed to add schedule.");
    }
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box box-body">
              <h4 className="box-title text-primary mb-0">
                <i className="ti-calendar me-15"></i> Add Schedule
              </h4>
              <hr className="my-15" />
              <form onSubmit={submitSchedule}>
                <div className="row">
                  {/* Client Dropdown */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Select Client</label>
                      <div className="select-container">
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <div
                          className="dropdown"
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #333",
                            borderRadius: "5px",
                            marginTop: "5px",
                          }}
                        >
                          {filteredOptions.length === 0 ? (
                            <div className="p-2">No matching clients</div>
                          ) : (
                            filteredOptions.map((client) => (
                              <button
                                key={client.id}
                                className={`form-control mt-2 ${
                                  client.id === scheduleData.clientId
                                    ? "bg-primary text-white"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleSelect(client.id);
                                }}
                              >
                                {client.name} - {client.companyName}
                              </button>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Add Client Button */}
                  <div className="col-md-6 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => (window.location.href = "/new-client")}

                    >
                       Add Client
                    </button>
                  </div>

                  {/* Schedule Date */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Schedule Date & Time</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="scheduleDate"
                        value={scheduleData.scheduleDate}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Type */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Type</label>
                      <select
                        className="form-control"
                        name="Type"
                        value={scheduleData.Type}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="Visit">Visit</option>
                        <option value="Call">Call</option>
                      </select>
                    </div>
                  </div>

                  {/* Status */}
                  {/* <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={scheduleData.status}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>
                  </div> */}

                  {/* Remarks */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">Remarks</label>
                      <textarea
                        className="form-control"
                        name="remarks"
                        value={scheduleData.remarks}
                        onChange={handleInputChange}
                        rows="3"
                      ></textarea>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AddSchedule;
